import * as React from "react";
import {List} from "@material-ui/core";
import ListIcon from "@material-ui/icons/List";
import {
    Description as DescriptionIcon
} from "@material-ui/icons";
import NiwListItem from "../NiwListItem";
import {useSelector} from "react-redux";
import {RootState} from "../../reducers";
import AddToQueueIcon from "@material-ui/icons/AddToQueue";

interface listItemType {
    url: string,
    title: string,
    listIcon: any
}

function TrusteeNavigation(props:{ handleNavClick: Function }) {
    const {handleNavClick} = props;
    const [routeName, setRouteName] = React.useState(window.location.pathname);
    const { user } = useSelector((state: RootState) => state.auth)

    const navigationsList = [
        {
            url: '/accounts/clients/individuals',
            title: 'Client Management',
            listIcon: <DescriptionIcon/>
        },
        {
            url: '/action-items',
            title: 'Action Items',
            listIcon: <ListIcon/>
        },
        {
            url: '/document-management',
            title: 'Document Management',
            listIcon: <AddToQueueIcon />
        }
    ];

    React.useEffect(() => {
        if (window.location.pathname === '/accounts') {
            setRouteName('/accounts/clients/individuals');
        } else {
            setRouteName(window.location.pathname);
        }

    }, [routeName]);

    return (
            <List className="leftNav">
                {
                    navigationsList.map((listItem: listItemType) => {
                                return (
                                        <NiwListItem
                                                key={listItem.url}
                                                url={listItem.url}
                                                title={listItem.title}
                                                listIcon={listItem.listIcon}
                                                routeName={routeName}
                                                setRouteName={setRouteName}
                                                user={user}
                                                handleNavClick={handleNavClick}
                                        />
                                )
                            }
                    )
                }
            </List>
    );
}

export default TrusteeNavigation;